import axios from "axios";

const axiosInstance = axios.create({
  // baseURL: "https://apidata.hogonnindia.com/",
  // baseURL: "https://apidata.hogonnindia.com/",
  // baseURL: "https://apidata.hogoautofilms.in/",
  baseURL: "https://apidata.hogonnindia.com/",
  // headers: {
  //   "Content-Type": "application/json",
  // },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);
export default axiosInstance;
